<template>
  <tci-recruit subtitle="PRE-SALES ENGINEER" :title="$t('recruit.mainPage.recruit_trans')" :recruits="infos"></tci-recruit>
</template>

<script>
import TciRecruit from "@/components/TciRecruit.vue";

export default {
  name: "RecruitTranslate",
  components: {
    "tci-recruit": TciRecruit
  },
  data: () => ({
    infos: [{"name":"高级售前工程师", "position":"苏州","email":"suzhou@trans-cosmos.com.cn","requests":[
      "负责生产型系统软件售前工作，并配合营业进行市场拓展；",
      "项目前期调研、分析客户业务需求，引导客户技术和产品选择；",
      "完成项目售前方案的制作、讲解以及产品演示；",
      "协助部门负责人开展部门其他工作。",
    ],"responses":[
      "本科以上学历，工业工程、工业自动化、计算机、信息管理等相关专业；",
      "熟悉生产制造业务，有至少2年制造行业MES或相关基干系统从业经验；",
      "思路清晰，具有较强的口头表达能力和书面表达能力，良好的PPT编写、方案演示和介绍技巧；",
      "具有良好的沟通能力、应变能力、团队合作意识，责任心强，承压能力强；",
      "有日资企业的工厂经验，尤其是生产管理，品质检查，生产准备等部门的优先考虑；",
      "日语2级相当能力者优先考虑。"
        ]}
    ]
  })
};
</script>
